import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VuetifyMask from "vuetify-mask";
import VueGtag from "vue-gtag";
import VueMeta from 'vue-meta'

Vue.use(VueSweetalert2);
Vue.use(Vuetify)
Vue.config.productionTip = false
Vue.use(VuetifyMask);
Vue.use(VueMeta)
Vue.use(VueGtag, {
  config: { id: "G-MTLL4292SY" }
},router);


new Vue({
  render: h => h(App),
  store,
  router,
  vuetify : new Vuetify({
    theme:{
        themes:{
            light:{
                primary : '#50c995',
                secondary : '#F6921E',
                warning: '#F6921E',
                orange:'#ffaa45',
                blue:'#26aeea',
                gray:'#87847b',
                grayblack:'#595754',
                graylight:'#c6c1af'
            }
        }
    }
  })
}).$mount('#app')


